import { Badge, BadgeProps } from '@payaca/ambrosia';
import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';

type EnaCommissioningStatusBadgeProps = Omit<
  BadgeProps,
  'colour' | 'variant'
> & {
  commissioningStatus: Nullish<string>;
};

const EnaCommissioningStatusBadge: FC<EnaCommissioningStatusBadgeProps> = ({
  commissioningStatus,
  ...badgeProps
}) => {
  return (
    <Badge
      variant="soft"
      {...badgeProps}
      colour={getCommissioningStatusBadgeColor(commissioningStatus)}
    >
      {prettifyCommissioningStatus(commissioningStatus)}
    </Badge>
  );
};

function getCommissioningStatusBadgeColor(
  commissioningStatus: Nullish<string>
): 'green' | 'yellow' | 'red' | 'gray' {
  if (!commissioningStatus) {
    return 'yellow';
  }
  const lowerStatus = commissioningStatus?.toLowerCase();

  if (lowerStatus.includes('accepted')) {
    return 'green';
  } else if (lowerStatus.includes('update required')) {
    return 'red';
  } else if (lowerStatus.includes('ex mpan provided')) {
    return 'green';
  } else {
    return 'gray';
  }
}

function prettifyCommissioningStatus(
  commissioningStatus: Nullish<string>
): string {
  if (!commissioningStatus) {
    return 'Submitted (Awaiting Approval)';
  }

  return commissioningStatus
    .split(/\s+/)
    .map((word) => {
      switch (word.toLowerCase()) {
        case 'ex':
          return 'Export';
        case 'cx':
          return 'Commissioning';
        case 'dno':
          return 'DNO';
        default:
          return word.charAt(0).toUpperCase() + word.slice(1);
      }
    })
    .join(' ');
}

export default EnaCommissioningStatusBadge;
